export default __webpack_public_path__ + "static/media/Native_select a kfc_grey image.6e97ff02.svg";